import type { CategoryPermissionResponse } from '@/shared/types/models/role.model'
import type { MenuItemNode } from './buildMenuFromTabs'

/** Đường dẫn Razor của DataSync trên BE (cùng host với API). */
export const DATA_SYNC_PATH = '/DataSync'

// p_function.Url: `/DataSync` (xem) và `/DataSync.Write` (sửa). So khớp không phân biệt hoa thường,
// giống DataSyncAuthPolicy ở BE.
const DATA_SYNC_FUNCTION_URLS = new Set(['/datasync', '/datasync.write'])
// Key của node là ID dòng menu (không cố định) nên nhóm được nhận theo nhãn.
const TRACKING_GROUP_LABEL = 'Theo dõi'

export const hasDataSyncPermission = (listTabs: CategoryPermissionResponse[] | null | undefined) =>
  (listTabs ?? []).some((category) =>
    (category.functions ?? []).some(
      (f) => f.isChecked && DATA_SYNC_FUNCTION_URLS.has((f.url ?? '').trim().toLowerCase())
    )
  )

const isTrackingGroup = (node: MenuItemNode) => node.label.trim() === TRACKING_GROUP_LABEL

/**
 * Gắn mục DataSync vào đầu nhóm "Theo dõi" khi người dùng có quyền xem hoặc sửa.
 * Không có nhóm đó trong menu (BE cắt nhóm rỗng) thì thêm thành mục cấp 1 ở cuối. Mục này trỏ ra trang Razor của BE
 * (`externalUrl`), không có `path` nên không lọt vào luồng router/breadcrumb.
 */
export const injectDataSyncMenu = (
  nodes: MenuItemNode[],
  listTabs: CategoryPermissionResponse[] | null | undefined,
  backendBaseUrl: string
): MenuItemNode[] => {
  if (!hasDataSyncPermission(listTabs)) return nodes

  const dataSyncNode: MenuItemNode = {
    key: 'data-sync',
    label: 'Đồng bộ dữ liệu',
    icon: 'SyncOutlined',
    externalUrl: `${backendBaseUrl.replace(/\/+$/, '')}${DATA_SYNC_PATH}`,
  }

  const trackingGroup = nodes.find(isTrackingGroup)
  if (!trackingGroup) return [...nodes, dataSyncNode]

  return nodes.map((node) =>
    node === trackingGroup ? { ...node, children: [dataSyncNode, ...(node.children ?? [])] } : node
  )
}
